import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { EnumTranslationService } from '../../services/enum-translation.service';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { IdProvider } from '../id-provider';

@Component({
    selector: 'app-multi-select-button-group',
    templateUrl: './multi-select-button-group.component.html',
    styleUrls: ['./multi-select-button-group.component.scss'],
    imports: [ReactiveFormsModule, NgClass, TranslateModule]
})
export class MultiSelectButtonGroupComponent implements OnInit {

  @Input() public fieldsEnum: any;
  @Input() public form: UntypedFormGroup;
  @Input() public translateKey = '';

  @Input() public hide: any[] = [];
  @Input() public fixedWidth = true;
  @Input() public inline = false;
  @Input() public cssClass = '';

  public id: string = IdProvider.getNextId();
  public keyList: any[];

  constructor(private formBuilder: UntypedFormBuilder,
              private enumTranslationService: EnumTranslationService) {
  }

  ngOnInit() {
    this.keyList = this.getKeys();
  }

  private getKeys(): any[] {
    return this.enumTranslationService.translateNumericEnum(this.fieldsEnum, this.translateKey)
      .filter(item => !this.hide.some(e => e === item.value));
  }

}
